export const dataStateType = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  BLOCK: "block",
};

export const statusOption = [
  {
    id: "active",
    name: "Active",
  },
  {
    id: "inactive",
    name: "Inactive",
  },
  {
    id: "block",
    name: "Block",
  },
];
